function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router-dom';
import { Badge, Button, DropdownMenu, DropdownMenuItem, IconButton, PageContentHeader, Typography } from 'seagull';
import { Insight, MoreVertical } from 'seagull/icons';
import { useEventReporter, useOverlayContext, useIoContext, useStore, useStoreActions } from "../../../../contexts";
import { useCopyDirectLink } from "../../../../hooks/useCopyDirectLink";
import { useTerminateAgreement } from "../../../../hooks/useTerminateAgreement";
import { useWithdrawToEditProposal } from "../../../../hooks/useWithdrawToEditProposal";
import { handlePromise } from "../../../../infra/utils";
import { useSendReminder } from "../../../../hooks/useSendReminder";
import { useOpenEditAgreementModal } from "../../../../hooks/useOpenEditAgreementModal";
import { routes } from "../../../../constants";
import { Intent } from "../../../../infra/access-control";
import { getAgreementPdfUrl } from "../../../../business-logic/relationshipLogic";
import MinisiteTabHeader from "../../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./Header.module.scss";
import { relationshipModel } from "../../../../models";
import { selectors } from "../../../../store/state-selectors";
import { useCopyProposalLink } from "../../../../hooks/useCopyProposalLink";
import { useProposalActions } from "../../../../hooks/useProposalActions";
import { compact } from 'lodash-es';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const testPrefix = 'agreement-minisite-topbar-';
const agreementStatusBadgeMap = {
  pending: 'Pending',
  terminated: 'Terminated',
  canceled: 'Canceled'
};
export default function Header(_ref) {
  let {
    relationship,
    onUpdate
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const {
    logBI
  } = useStoreActions();
  const pdfHost = useStore(selectors.pdfHost);
  const {
    reportPopupAction
  } = useEventReporter();
  const {
    withdrawToEditProposalByIdWithConfirmation
  } = useWithdrawToEditProposal();
  const userIsVendor = relationship.vendor.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId());
  const agreementStatusString = agreementStatusBadgeMap[relationship.status];
  const {
    terminateAgreementById
  } = useTerminateAgreement();
  const openEditModeModal = useOpenEditAgreementModal();
  const {
    copyDirectLink
  } = useCopyDirectLink();
  const {
    sendReminder
  } = useSendReminder();
  const overlayContext = useOverlayContext();
  const {
    copyToClipboard,
    openNewTab
  } = useIoContext();
  const history = useHistory();
  const {
    getAgreementNotificationLink
  } = useCopyProposalLink();
  const {
    getCancelProposalAction
  } = useProposalActions();
  const overflowMenuActions = compact([relationshipModel.isPending(relationship) && userIsVendor && {
    intent: Intent.SendProposalReminder,
    text: 'Resend link to customer',
    testid: 'resend',
    onClick: () => sendReminder(relationship)
  }, relationshipModel.isPending(relationship) && userIsVendor && {
    intent: Intent.CopyRelationshipDirectLink,
    text: 'Copy agreement link',
    testid: 'copy',
    onClick: async () => {
      const {
        vendor,
        customer,
        progressStatus
      } = relationship;
      logBI(10586, {
        vendorId: vendor.id,
        clientId: customer.id,
        agreementStatus: progressStatus
      });
      overlayContext.startLoader();
      const {
        success,
        data
      } = await handlePromise(getAgreementNotificationLink(relationship.id));
      overlayContext.stopLoader();
      if (success) {
        try {
          // This will fail if the document loses focus.
          copyToClipboard(data);
          overlayContext.showSuccessToast('Link copied to clipboard');
        } catch (err) {
          overlayContext.showErrorToast('Failed to copy link to clipboard');
        }
      }
    }
  }, relationshipModel.isPending(relationship) && userIsVendor && _objectSpread(_objectSpread({}, getCancelProposalAction(relationship.id, async () => history.push(routes.home))), {}, {
    testid: 'cancel'
  }), userIsVendor && {
    intent: Intent.CopyRelationshipDirectLink,
    text: 'Copy link',
    testid: 'copy',
    onClick: () => {
      copyDirectLink(relationship.id, {
        type: 'agreement',
        id: relationship.id
      });
      logBI(14000);
    }
  }, (relationshipModel.isApproved(relationship) || relationshipModel.isTerminated(relationship)) && {
    intent: Intent.DownloadAgreementPdf,
    text: 'Download PDF',
    testid: 'download-pdf',
    onClick: () => openNewTab(getAgreementPdfUrl(relationship.id, pdfHost))
  }, relationshipModel.isApproved(relationship) && userIsVendor && {
    intent: Intent.TerminateAgreement,
    text: 'Terminate this agreement',
    testid: 'terminate',
    onClick: () => {
      reportPopupAction('terminate-agreement-modal');
      terminateAgreementById({
        id: relationship.id,
        postAction: () => onUpdate()
      });
    }
  }]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MinisiteTabHeader, {
      appcuesId: "agreement-view-header",
      actions: /*#__PURE__*/_jsxs("div", {
        className: styles.actions,
        "data-appcuesid": "agreement-view-actions",
        children: [agreementStatusString && /*#__PURE__*/_jsx(Badge, {
          size: "big",
          skin: "warning",
          "data-testid": testPrefix + 'badge-status',
          "data-status": relationship.status,
          children: agreementStatusString
        }), userIsVendor && !relationshipModel.isTerminated(relationship) && /*#__PURE__*/_jsx(Button, {
          onClick: () => {
            if (relationshipModel.isPending(relationship)) {
              withdrawToEditProposalByIdWithConfirmation(relationship.id, relationship.draftId);
            } else {
              openEditModeModal({
                relationship,
                onUpdate
              });
            }
          },
          "data-testid": testPrefix + 'btn-edit-sow',
          disabled: relationship.isSample,
          children: "Edit"
        }), overflowMenuActions.length > 0 && /*#__PURE__*/_jsx(DropdownMenu, {
          target: /*#__PURE__*/_jsx(IconButton, {
            "data-testid": testPrefix + 'vendor-overflow-button',
            children: /*#__PURE__*/_jsx(MoreVertical, {})
          }),
          children: overflowMenuActions.map(_ref2 => {
            let {
              intent,
              text,
              testid,
              onClick
            } = _ref2;
            return /*#__PURE__*/_jsx(DropdownMenuItem, {
              intent: intent,
              "data-testid": "".concat(testPrefix, "overflow-").concat(testid),
              onClick: onClick,
              children: text
            }, text);
          })
        })]
      })
    }), relationship.isSample && /*#__PURE__*/_jsx(PageContentHeader, {
      children: /*#__PURE__*/_jsxs("div", {
        "data-testid": testPrefix + 'sample-banner',
        className: styles.sampleAgreementBanner,
        children: [/*#__PURE__*/_jsx(Insight, {}), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          weight: "light",
          className: styles.sampleAgreementBannerText,
          children: "You're currently reviewing a test agreement. Feel free to play around, nothing will be saved"
        })]
      })
    })]
  });
}